var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaLinkedinIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1483_13167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 29.9995C23.2843 29.9995 30 23.2838 30 14.9995C30 6.71524 23.2843 -0.000488281 15 -0.000488281C6.71573 -0.000488281 0 6.71524 0 14.9995C0 23.2838 6.71573 29.9995 15 29.9995Z",
    fill: "#007AB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9625 16.2066V22.3908H20.377V16.6211C20.377 15.1724 19.8594 14.183 18.5612 14.183C17.5705 14.183 16.982 14.8491 16.7221 15.494C16.6277 15.7245 16.6034 16.0446 16.6034 16.3678V22.3905H13.0177C13.0177 22.3905 13.0658 12.6185 13.0177 11.607H16.6036V13.1351C16.5964 13.1471 16.5863 13.1589 16.5798 13.1704H16.6036V13.1351C17.0801 12.4019 17.9299 11.3538 19.835 11.3538C22.1939 11.3538 23.9625 12.895 23.9625 16.2066ZM9.26674 6.40894C8.04023 6.40894 7.23779 7.21404 7.23779 8.27184C7.23779 9.30717 8.01696 10.1355 9.21968 10.1355H9.24295C10.4935 10.1355 11.2711 9.30717 11.2711 8.27184C11.2473 7.21404 10.4935 6.40894 9.26674 6.40894ZM7.4509 22.3908H11.0353V11.607H7.4509V22.3908Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1483_13167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaLinkedinIn);
export default __webpack_public_path__ + "static/media/FaLinkedinIn.c3d6e2557f9a5dc254ad8e2d0fdbf09b.svg";
export { ForwardRef as ReactComponent };